import { render } from "./classify.vue?vue&type=template&id=3b1e0898&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"

import "./classify.vue?vue&type=style&index=0&id=3b1e0898&lang=scss&scoped=true"
import "./classify.vue?vue&type=style&index=1&id=3b1e0898&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1e0898"]])

export default __exports__